import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/annual-report/2025/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/annual-report/2025',
  name: 'annual_report_2025',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2025年度运动报告',
    keepAlive: true,
    expiryDate: '2026-02-28',
  },
}

export default [indexRoute]
